
const IntroSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Comprehensive OSHA Safety Training For Your Employees
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              As a company owner, you have a moral and legal obligation to provide your employees with a safe working environment. The Occupational Safety and Health Administration (OSHA) requires you to train all employees on the hazards they will encounter in their daily work, regardless of the industry. If you fail to comply with regulations, there can be significant fines and legal consequences. Safety Consultants USA is here to help you navigate the complex world of OSHA requirements and provide the necessary training to keep your employees safe and your business compliant.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;